/**
 * Polish stopwords (~290) uzywane w:
 * - wpHtmlAnalyzer (keyword stuffing detection)
 * - textNormalization.normalizeToTokens (SRO matcher Jaccard/containment)
 *
 * WAZNE: wszystkie stopwords zapisane BEZ diakrytykow, bo tokenize pipeline
 * robi stripPolishDiacritics PRZED lookupem. Diakrytyczne formy (ę/ą/ś/ż)
 * bylyby niedopasowane po stripie.
 *
 * Wersja z PLAN-MATCHER-SRO — 212 wyjsciowych + ~80 brakujacych pytajnikow,
 * form czasownikow byc/miec, funkcyjnych, wysokoczestotliwosciowych.
 */

export const POLISH_STOPWORDS: string[] = [
  // Spojniki i partykuly (bazowe, 212 było)
  "a", "aby", "ach", "acz", "aczkolwiek", "aj", "albo", "ale", "alez", "ani", "az",
  "bardziej", "bardzo", "bez", "bo", "bowiem", "by", "byc", "byl", "byla",
  "byli", "bylo", "byly", "bynajmniej", "cala", "cali", "caly", "ci", "cie",
  "ciebie", "co", "cokolwiek", "cos", "czasami", "czasem", "czemu", "czy",
  "czyli", "daleko", "dla", "dlaczego", "dlatego", "do", "dobrze", "dokad",
  "dosc", "duzo", "dwa", "dwaj", "dwie", "dwoje", "dzis", "dzisiaj", "gdy",
  "gdyby", "gdyz", "gdzie", "gdziekolwiek", "gdzies", "go",
  "i", "ich", "ile", "im", "inna", "inne", "inny", "innych", "iz",
  "ja", "jak", "jakby", "jaki", "jakie", "jakis", "jakiz", "jakkolwiek", "jako", "jakos",
  "je", "jeden", "jedna", "jedno", "jednak", "jednakze", "jego",
  "jej", "jemu", "jest", "jestem", "jeszcze", "jesli", "jezeli", "juz", "kazdy",
  "kiedy", "kierunku", "kilka", "kims", "kto", "ktokolwiek", "ktos", "ktora",
  "ktore", "ktorego", "ktorej", "ktory", "ktorych", "ktorym", "ktorzy", "ku",
  "lat", "lecz", "lub", "ma", "maja", "malo", "mam", "mi", "mimo", "miedzy",
  "mna", "mnie", "moga", "moim", "moj", "moja", "moje", "moze", "mozliwe",
  "mozna", "mu", "my", "na", "nad", "nam", "nami", "nas", "nasi", "nasz",
  "nasza", "nasze", "naszego", "naszych", "natomiast", "natychmiast", "nawet",
  "nia", "nic", "nich", "nie", "niech", "niego", "niej", "niemu", "nigdy",
  "nim", "nimi", "niz", "no", "o", "obok", "od", "okolo", "on", "ona", "one",
  "oni", "ono", "oraz", "oto", "owszem", "pan", "pana", "pani", "po", "pod",
  "podczas", "pomimo", "ponad", "poniewaz", "powinien", "powinna", "powinni",
  "powinno", "poza", "prawie", "przeciez", "przed", "przede", "przedtem",
  "przez", "przy", "roku", "rowniez", "sam", "sama", "sie", "skad", "soba",
  "sobie", "sposob", "swoje", "ta", "tak", "taka", "taki", "takie", "takze",
  "tam", "te", "tego", "tej", "ten", "teraz", "tez", "to", "toba", "tobie",
  "totez", "trzeba", "tu", "tutaj", "twoi", "twoj", "twoja", "twoje", "twym",
  "ty", "tych", "tylko", "tym", "u", "w", "was", "wasi", "wasz", "wasza",
  "wasze", "we", "wedlug", "wiele", "wielu", "wiec", "wiecej", "wlasnie",
  "wszyscy", "wszystkich", "wszystkie", "wszystkim", "wszystko", "wtedy",
  "wy", "z", "za", "zaden", "zadna", "zadne", "zadnych", "zapewne", "zawsze",
  "ze", "zeby", "zeznow", "znow", "zostal", "zostala", "zostali", "zostalo",

  // +80 brakujacych (plan SRO sec. POLISH_STOPWORDS)
  // Pytajniki (question words)
  "jaka", "jakim", "jakich", "jakimi",
  "czym", "czego",
  "odkad", "dokadze",
  // Funkcyjne dodatkowe
  "swoj", "swoja", "swoje", "swego", "swej", "swoim", "swoimi",
  // By forms
  "jestes", "jestesmy", "jestescie", "sa",
  "bylem", "bylas", "beda", "bedzie", "bede", "bedziesz", "bedziemy", "bedziecie",
  // Mieć forms
  "mass", "mamy", "macie", "mial", "miala", "mielam", "miales", "mielismy", "mieliscie",
  // Wysokoczestotliwosciowe
  "musi", "musza", "musimy", "muszą", "musicie", "musze", "musisz",
  "nalezy", "warto", "lepiej", "gorzej", "mniej", "oboj", "obie",
  "kazdemu", "kazda", "kazde", "kazdego", "kazdym",
  "coraz", "niemal", "jedynie", "zaledwie", "przecie",
  "istotnie", "zatem", "wlasciwie", "raczej", "zwlaszcza",
  "chyba", "moglismy", "mozemy", "moglby", "moglaby", "mogloby",
  "powinno", "powinny", "powinien", "powinnismy",
  // Przyimki / kierunkowe dodatkowe
  "wobec", "wskutek", "przed", "ponad", "poza",
  // Specyficzne SEO-spam words (niskiej wartosci)
  "dowiesz", "poznaj", "sprawdz", "odkryj", "zobacz",
];

/**
 * Set dla O(1) lookup.
 */
export const POLISH_STOPWORDS_SET: Set<string> = new Set(POLISH_STOPWORDS);

/**
 * Remove diacritics from Polish characters (dla porownan insensitive).
 * ą→a, ć→c, ę→e, ł→l, ń→n, ó→o, ś→s, ź→z, ż→z
 */
export function stripPolishDiacritics(text: string): string {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/ł/g, "l")
    .replace(/Ł/g, "L");
}

/**
 * Tokenize text for Jaccard / keyword stuffing:
 * - lowercase
 * - strip diacritics
 * - split by non-word chars
 * - filter length>2, no stopwords
 */
export function tokenizeWithoutStopwords(text: string): string[] {
  const normalized = stripPolishDiacritics(text.toLowerCase());
  return normalized
    .split(/\W+/)
    .filter((t) => t.length > 2 && !POLISH_STOPWORDS_SET.has(t));
}
